import useLifecycle, { LIFECYCLE } from 'hooks/useLifecycle';

import { useRivalsSawPlayButtonOnboarding } from './useRivalsSawPlayButtonOnboarding';
import { useRivalsSawWelcomeToTheArena } from './useRivalsSawWelcomeToTheArena';

export const useSawRivalsPlayPageHighlight = () => {
  const { lifecycle } = useLifecycle();
  const sawWelcomeToTheArena = useRivalsSawWelcomeToTheArena();
  const sawPlayButtonOnboarding = useRivalsSawPlayButtonOnboarding();

  // Adding sawWelcomeToTheArena and sawPlayButtonOnboarding to make sure older users are considered has having seen the onboarding
  return (
    lifecycle?.[LIFECYCLE.sawRivalsPlayPageHighlight] ||
    sawPlayButtonOnboarding ||
    sawWelcomeToTheArena
  );
};
